import { Conjunt } from "./conjunt.model";
import { ResponsePregunta } from "./response_pregunta.model";

export class ResponseValoracio {
    accionsPregunta: ResponsePregunta;
    collaboraPregunta: ResponsePregunta;
    coneixementPregunta: ResponsePregunta;
    explicacionsPregunta: ResponsePregunta;
    factorsPregunta: ResponsePregunta;
    grauPregunta: ResponsePregunta;
    observadorPregunta: ResponsePregunta;
    vinclePregunta: ResponsePregunta;
    altresFactorsObservacions: ResponsePregunta;
}